<script>
import { Bar } from 'vue-chartjs'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { debug } from 'util';
import DateFormatter from '../../plugins/dateFormatter'
export default {
  extends: Bar,
  data: () => {
    return {
      chartData: {},
      dates: [],
      bounceRate: []
    }
  },
  async mounted () {
    // Overwriting base render method with actual data.
    setTimeout(() => { 
    this.chartData = this.$store.state.mainOverviewsData
    this.chartData.data.forEach(element => {
      this.dates.push(DateFormatter(element.data_date))
      this.bounceRate.push(parseInt(element.bounce_rate));
    });
    this.renderChart(
      {
        labels: this.dates,
        datasets: [
          {
            label: 'Weekly Bounce Rate',
            backgroundColor: '#fff',
            data: this.bounceRate
          }
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          enabled: false,
          custom: CustomTooltips,
          intersect: true,
          mode: 'index',
          position: 'nearest',
          callbacks: {
            labelColor: function (tooltipItem, chart) {
              return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor }
            }
          }
        }
      }
    )
    }, 1500);
  }
}
</script>
